module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"category":"Category"},"fr":{"info":"Info","warning":"Warning","alert":"Alerte","critical":"Critique"},"de":{"info":"Die Info","warning":"Warnung","alert":"Alarm","critical":"Kritik"}}')
  delete Component.options._Ctor
}
